import React from 'react';
import TeamVideo from '../components/TeamVideo';
import Hero from '../components/Hero';
import Badges from '../components/Badges';
import MainServices from '../components/MainServices';
import About from '../components/About';
import Contact from '../components/Contact';
import AskAI from '../components/AskAI';

const Inicio = () => {
  return (
    <>
      <TeamVideo />
      <Hero />
      <Badges />
      <MainServices />
      <About />
      <Contact />
      <AskAI />
    </>
  );
};

export default Inicio;